<template>
<div class="user-student">
    <el-form :inline="true" :model="dataForm">
        <el-form-item label="">
            <el-input v-model.trim="dataForm.realName" placeholder="学生真实姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-input v-model.trim="dataForm.remark" placeholder="备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
            <el-dict-select placeholder="班主任" v-model="teacherId" type="teacherSelects" :props="{label: 'realName', value: 'userId'}"></el-dict-select>
        </el-form-item>
        <el-form-item label="" prop="studentGroupId">
            <el-dict-select placeholder="班级" v-model="dataForm.studentGroupId" type="studentGroups" :props="{label: 'groupName', value: 'id'}" :params="groupTeacherParams"></el-dict-select>
        </el-form-item>
        <el-form-item label="">
            <el-dict-select v-if="manageOrgIdFlag()" placeholder="选择机构" v-model="dataForm.orgId" type="orgList"></el-dict-select>
        </el-form-item>
        <el-form-item>
            <el-dict-select placeholder="学段" v-model="dataForm.userStage" type="openDict" :props="dictProps" :params="groupStageParams"></el-dict-select>
        </el-form-item>
        <el-form-item>
            <el-dict-select v-model="dataForm.userStageLevel" placeholder="阶段" type="openDict" :props="dictProps" :params="userStageLevelParams"></el-dict-select>
        </el-form-item>
        <el-form-item label="">
            <el-dict-select placeholder="账户状态" v-model="dataForm.status" type="listByType" :props="dictProps" :params="statusParams"></el-dict-select>
        </el-form-item>
        <el-form-item label="">
            <el-select v-model="dataForm.classStatus" clearable placeholder="上课状态">
            <el-option label="上课中" value=1></el-option>
            <el-option label="停课" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button @click="rgetDataList()">查询</el-button>
        </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 1rem;">
        <el-col>
            <el-button v-if="isAuth('sys:student-user:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
            <el-button type="success" v-if="isAuth('sys:multi-course:save')" @click="handlePatch">批量排课</el-button>
            <el-button type="info" @click="excel" v-if="isAuth('sys:student:export')">导出<i class="el-icon-download"></i>
            </el-button>
        </el-col>
    </el-row>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="handleSelectionChange" style="width: 100%;">
        <el-table-column type="selection"></el-table-column>
        <el-table-column type="index" header-align="center" align="center" label="序号" :index="indexMethod" width="50">
        </el-table-column>
        <el-table-column prop="realName" header-align="center" align="center" label="姓名">
        </el-table-column>
        <el-table-column prop="username" header-align="center" align="center" label="账户名">
        </el-table-column>
        <el-table-column prop="age" header-align="center" align="center" label="年龄">
        </el-table-column>
        <el-table-column v-if="manageOrgIdFlag()" prop="orgName" header-align="center" align="center" label="所属机构">
        </el-table-column>
        <el-table-column prop="courseAllNum" header-align="center" align="center" label="全部课时">
        </el-table-column>
        <el-table-column prop="consumeCourseNum" header-align="center" align="center" label="已上课时">
        </el-table-column>
        <el-table-column prop="courseLimit" header-align="center" align="center" label="剩余课时">
        </el-table-column>
        <el-table-column prop="studentGroupName" header-align="center" align="center" label="班级">
        </el-table-column>
        <el-table-column header-align="center" prop="userStageName" align="center" label="学段">
        </el-table-column>
        <el-table-column prop="userStageLevelName" header-align="center" align="center" label="阶段">
        </el-table-column>
        <el-table-column prop="gender" header-align="center" align="center" width="40" label="性别">
            <template slot-scope="{ row }">
                {{ getSysDictVal("Gender", row.gender) }}
            </template>
        </el-table-column>
        <el-table-column prop="mobile" header-align="center" align="center" width="110" label="手机号">
        </el-table-column>
        <!-- <el-table-column prop="email" header-align="center" align="center" width="150" label="邮箱">
        </el-table-column> -->
        <el-table-column prop="classStatus" header-align="center" align="center" label="上课状态">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.classStatus === 0" size="small" type="danger">停课</el-tag>
                <el-tag v-else size="small">上课中</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="status" header-align="center" align="center" label="账户状态">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status === '0'" size="small" type="danger">禁用</el-tag>
                <el-tag v-else size="small">启用</el-tag>
            </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" width="150" label="操作">
            <template slot-scope="{ row }">
                <el-button v-if="isAuth('sys:student-user:disable')" :disabled="row.status === '1'" type="text" size="small" @click="update(row.userId, {status : '1'})">
                    启用
                </el-button>
                <el-button v-if="isAuth('sys:student-user:disable')" style="color:#F56E6E" :disabled="row.status === '0'" type="text" size="small" @click="update(row.userId, {status : '0'})">
                    禁用
                </el-button>
                <el-button v-if="isAuth('sys:student-user:courseNum')" type="text" size="small" @click="UpdateCourseHandle(row.userId)">课包合约</el-button>
                <!--<el-button v-if="isAuth('sys:student-user:courseNum')" type="text" size="small" @click="UpdateOtherContractHandle(row)">单独缴费合约</el-button>-->
                <el-button v-if="isAuth('sys:student-user:update')" type="text" size="small" @click="addOrUpdateHandle(row.userId,row.orgId)">
                    修改
                </el-button>
                <el-button v-if="isAuth('sys:student-user:delete')" type="text" size="small" @click="deleteHandle(row)" style="color:#F56E6E">
                    删除
                </el-button>
                <el-button v-if="isAuth('sys:student-user:disable')" :disabled="row.classStatus === 1" type="text" size="small" @click="update(row.userId, {classStatus : '1'})">
                    上课中
                </el-button>
                <el-button v-if="isAuth('sys:student-user:disable')"  :disabled="row.classStatus === 0" type="text" size="small" @click="update(row.userId, {classStatus : '0'})">
                    停课
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="createTime" header-align="center" align="center" width="160" label="创建时间">
        </el-table-column>
        <el-table-column prop="remark" header-align="center" align="center" width="160" label="备注">
        </el-table-column>
        <!--<el-table-column prop="updateTime" header-align="center" align="center" width="160" label="修改时间">
        </el-table-column>-->
        <el-table-column prop="opsName" header-align="center" align="center" width="50" label="修改人">
        </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <el-dialog title="该合约适用于单独缴费、不划课时的情况" :visible.sync="dialogOtherContractVisible">
        <el-form :model="otherForm" :rules="dataRule" ref="otherForm">
            <el-form-item label="缴费金额" prop="totalAmount">
                <el-input-number v-model="otherForm.totalAmount" controls-position="right"></el-input-number>
            </el-form-item>
            <el-form-item label="合约备注" prop="remark">
                <el-input v-model="otherForm.remark" type="textarea" style="width: 580px" placeholder="请输入备注"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <span style="margin-right: 300px; font-size: xx-small"><span style="color: red">注意事项</span>: 确认上课状态不要扣课时</span>
            <el-button @click="dialogOtherContractVisible = false">取 消</el-button>
            <el-button type="primary" @click="UpdateOtherContractSubmmit">确 定</el-button>
        </div>
    </el-dialog>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    <update-course-num v-if="updateCourseNumVisible" ref="updateCourseNum" @refreshDataList="getDataList"></update-course-num>
    <!-- 排课 -->
    <stu-pai-ke ref="paike" v-model="drawerVisible" @submit="handleSubmit"></stu-pai-ke>
</div>
</template>

<script>
import AddOrUpdate from './student-add-or-update'
import UpdateCourseNum from './student-course-num'
import stuPaiKe from './stu-paike'
import {
    getLoginToken
} from "../../../utils";
export default {
    data() {
        return {
            selected: [],
            teacherId: '',
            drawerVisible: false,
            dialogOtherContractVisible: false,
            dataForm: {
                realName: '',
                username: '',
                studentGroupId: '',
                orgId: '',
                status: '',
                classStatus: '1'
            },
            otherForm: {
                totalAmount: '',
                realName: '',
                remark: '',
                userId: ''
            },
            courseLimit: 0,
            inputCourseLimit: 0,
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            addOrUpdateVisible: false,
            updateCourseNumVisible: false,
            dataRule: {
                remark: [{
                    required: true,
                    message: "备注不能为空",
                    trigger: "blur"
                }, ],
                totalAmount: [{
                    required: true,
                    message: "缴费金额不能为空",
                    trigger: "blur"
                }, ],
            },
        }
    },
    computed: {
        statusParams() {
            return {
                type: 'UserStatus'
            }
        },
        dictProps() {
            return {
                label: 'value',
                value: 'code'
            }
        },
        groupTeacherParams() {
            return {
                type: this.teacherId
            }
        },
        groupStageParams() {
            return {
                type: 'StudentStage'
            }
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage
            }
        },
        userTypeParams() {
            return {
                type: 'UserType'
            }
        }
    },
    components: {
        AddOrUpdate,
        stuPaiKe,
        UpdateCourseNum
    },
    created() {
        this.getDataList()
        this.doSearch();
    },
    methods: {
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        update(id, data) {
            this.$http({
                url: this.$http.adornUrl(`sys/user/update/${id}`),
                method: 'put',
                data: this.$http.adornData({
                    userType: 'STUDENT',
                    ...data
                })
            }).then(({
                data
            }) => {
                if (data.code === 0) {
                    this.$message.success('更新成功！')
                    this.getDataList()
                } else {
                    this.$message(data.msg)
                }
            })
        },
        doSearch() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.getDataList();
                }
            }
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('sys/user/list'),
                method: 'get',
                params: this.$http.adornParams({
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    ...this.dataForm,
                    'userType': 'STUDENT'
                })
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.dataList = data.page.list
                    this.totalPage = data.page.totalCount
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        handleSelectionChange(val) {
            // console.log('handleSelectionChange', val)
            this.selected = val
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 新增 / 修改
        addOrUpdateHandle(id, orgId) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, orgId)
            })
        },
        // 课包合约
        UpdateCourseHandle(id) {
            this.updateCourseNumVisible = true
            this.$nextTick(() => {
                this.$refs.updateCourseNum.init(id)
            })
        },
        // 其他合约
        UpdateOtherContractHandle(row) {
            this.dialogOtherContractVisible = true
            this.otherForm.userId = row.userId
            this.otherForm.realName = row.realName
        },
        handleSubmit(val) {
            const studentIds = this.selected.map(i => i.userId)
            const classRecords = val.map(i => ({
                courseId: i.id,
                endTime: i.endTime,
                startTime: i.startTime,
                userId: i.userId
            }))
            
            this.$http({
                url: this.$http.adornUrl('course/record/multiSave'),
                method: 'post',
                data: this.$http.adornData({
                    studentIds,
                    classRecords
                })
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.$message({
                        message: '排课成功',
                        type: 'success'
                    })
                    this.drawerVisible = false
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        handlePatch() {
            if (this.selected.length === 0) {
                this.$message.warning('请先勾选学生！')
                return
            }
            const isClassing = this.selected.filter(i => i.classStatus === 0)
            if (isClassing.length > 0) {
                this.$message.warning('有学生暂停排课，请先改变他的上课状态！')
                return
            }
            const isClassLimit = this.selected.filter(i => i.courseLimit === 0)
            if (isClassLimit.length > 0) {
                this.$message.warning('有学生没有课时，暂时无法排课，请重新选择！')
                return
            }
            
            this.drawerVisible = true
            const studentUserIds = this.selected.map(i => i.userId)
            const groupId = this.dataForm.studentGroupId
            this.$nextTick(() => {
                this.$refs.paike.getDataList(studentUserIds, groupId)
            }) 
        },
        excel() {
            let url = this.$http.adornUrl("sys/user/studentExcel")
            let param = "?token=" + getLoginToken()
            param += "&realName=" + this.dataForm.realName
            param += "&username=" + this.dataForm.username
            param += "&studentGroupId=" + this.dataForm.studentGroupId
            param += "&status=" + this.dataForm.status
            param += "&orgId=" + this.dataForm.orgId
            url = url + param;
            window.location.href = url;
        },
        // 删除
        deleteHandle(row) {
            const {
                userId,
                username
            } = row
            this.$confirm(`确定删除${username}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$http.adornUrl('sys/user/delete'),
                    method: 'delete',
                    data: userId
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        UpdateOtherContractSubmmit() {
            this.$refs["otherForm"].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: this.$http.adornUrl('sys/user/updateOtherContract'),
                        method: 'put',
                        data: this.$http.adornParams({
                            userId: this.otherForm.userId,
                            totalAmount: this.otherForm.totalAmount,
                            remark: this.otherForm.remark,
                            studentName: this.otherForm.realName,
                        })
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: '新增成功',
                                type: 'success'
                            })
                            this.getDataList()
                            this.dialogOtherContractVisible = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })

                }
            });
        }
    }
}
</script>
